// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import EditTwoToneSvg from "@fishx/icons-svg/es/asn/EditTwoTone";
import FishxIcon from '../components/FishxIcon';

var EditTwoTone = function EditTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: EditTwoToneSvg
  }));
};

EditTwoTone.displayName = 'EditTwoTone';
export default React.forwardRef(EditTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/EditTwoTone.js
// module id = 2593
// module chunks = 0